<template>
  <b-card class="mb-0">
    <template v-slot:header>
      <div class="d-flex">
        <slot name="header">
          <div class="no-print d-flex flex-row pr-1 pl-0 mb-1"> 
            <button-refresh size="md" style="border-radius: 4px 0px 0px 4px;" :animate="animateRefresh" :disabled="isBusy || isBusyInner" class="align-self-start" @click="autoUpdateSec=0; $refs['page-table'].getData(); $emit('onRefreshClick');"/>
            <b-input style="border-radius: 0px 4px 4px 0px; width: 60px;" :disabled="false" type="number" min="0" max="300" step="30" v-model="autoUpdateSec"></b-input>
          </div>

          <h4 v-if="title" class="card-title m-0 mr-2 mb-2 mt-1">{{title}}</h4>
        </slot>

        <div class="no-print d-flex">
          <slot name="filter"></slot>
        </div>
        
        <div class="d-flex ml-auto">
          <slot name="header-actions" class="no-print">
            <button-add 
              :disabled="isBusy || isBusyInner"
              class="align-self-start mt-1 mb-2"
              v-if="showAddButton || (showAddButton === null && ($store.getters.isSuperAdmin || $store.getters.isAdmin || $store.getters.isSuperUser))" 
              @click="$emit('onAdd')" 
            />
          </slot>
          
          <b-dropdown right size="sm" variant="secondary" class="no-print align-self-start ml-1 mt-1 mr-1">
            <template #button-content>
              <i class="fa fa-file-excel-o"></i>
            </template>
            
            <b-dropdown-item @click="$refs['page-table'].getExcellData()">
              <i :class="getIconClassByReportType('excell')"></i>
              Экспорт таблицы в Excell
            </b-dropdown-item>
            <b-dropdown-divider v-if="reports.length > 0"/>
            <b-dropdown-item v-for="report in reports" :key="report.id" @click="reportClick(report.reportItem)">
              <i :class="getIconClassByReportType(report.reportItem.reportType)"></i>
              {{ report.name }}
            </b-dropdown-item>
            <slot name="export-items"></slot>
          </b-dropdown>

          <h3><b-badge class="align-self-start ml-2" variant="success">{{totalItems}}</b-badge></h3>
        </div>
      </div>
    </template>

    <page-table 
      id="base-table-card"
      ref="page-table"
      :primaryKey="primaryKey"
      :fields="fields"
      :hideFields="hideFields"      
      :updateIntervalSec="Number(autoUpdateSec)"
      :getDataFunction="getDataFunction"
      :getDataFunctionParam="getDataFunctionParam"
      :isBusy="isBusy"
      :isSortable="isSortable"
      :perPage="perPage"

      @onBusy="isBusyInner=$event"
      @dataChanged="totalItems = $event.totalItems; $emit('dataChanged', $event)"
      @animateRefresh="animateRefresh=$event"
      @onSortHeadClicked="$emit('onSortHeadClicked', $event)" 
      @rowClicked="$emit('rowClicked', $event)"      
    >

    <template v-for="(_, slot) of $slots" :slot="slot">
      <slot :name="slot"/>
    </template>

    <template v-for="(_, slot) of $scopedSlots" #[slot]="scope">
      <slot :name="slot" v-bind="scope"/>
    </template>

    </page-table>

    <report-viewer-modal :id="'report-viewer-modal-reports'+reportId" :title="currentReport.reportName" :reportType="currentReport.reportType" :report="currentReport.dataReport" :dataSets="null"/>
  </b-card>
  
</template>

<script>
  import ReportService from '@/services/web/report.service'
  import ReportViewerModal from '@/views/reports/ViewerModal.vue'

export default {
  name: 'base-table-card',
  inheritAttrs: false,
  components: {ReportViewerModal},

  props: {
    title: {
      type: String,
      default: null
    },

    fields: {
      type: [Array, Function],
      default: () => []
    },

    hideFields: {
      type: [Array, Function],
      default: () => []
    },

    primaryKey: {
      type: String,
      default: 'id'
    },

    getDataFunction: {
      type: Function,
      default: null
    },

    getDataFunctionParam:{
      type: Object,
      default: null
    },

    showAddButton: {
      type: Boolean,
      default: null
    },

    isBusy: {
      type: Boolean,
      default: false
    },

    isSortable: {
      type: Boolean,
      default: true      
    },

    perPage: {
      type: Number,
      default: 15
    }
  },

  data: () => {
    return {
      animateRefresh: false,
      totalItems: 0,
      isBusyInner: false,
      autoUpdateSec: 0,

      reports: [],
      currentReport: {},
      reportId: '',
    }
  },

  watch: {
    autoUpdateSec() {
      if (this.autoUpdateSec > 0 && this.autoUpdateSec < 30) {
        this.autoUpdateSec = 30
      }
    }
  },

  methods: {
    getItems() {
      return this.$refs['list-table'].getItems()
    },

    getData(tableBusy) {
      this.$refs['page-table'].getData(tableBusy)
    },

    reportClick(reportItem) {
      this.currentReport = reportItem
      this.$bvModal.show('report-viewer-modal-reports'+this.reportId)
    },

    getReports() {
      ReportService.get(null, this.$route.path, null)
      .then(result => {
        if(result.data) {
          result.data.forEach(item => {
            this.reports.push({name: item.reportName, reportItem: item})
          })
        }
      })
      .catch( exc => {
        console.log('Error getReports() ' + exc)
      })
    }
  },

  mounted() {
    this.reportId = String(Math.random()) // crypto.randomUUID()
    this.getReports()
  }
}

</script>
